import type { Language } from '@eliadmin/core/src/api/general/types/general-types';

export const LOCALES: Language[] = [
  {
    "id": 1,
    "name": "Slovenský jazyk",
    "locale": "sk",
    "image": {
      "id": 2,
      "name": "sk.svg",
      "url": "https://api.lumibau.com/files/sk.svg?ai=0",
      "custom_title": "sk",
      "is_ai_generated": false
    },
    "is_default": true
  },
  {
    "id": 3,
    "name": "Anglický jazyk",
    "locale": "en",
    "image": {
      "id": 4,
      "name": "gb.svg",
      "url": "https://api.lumibau.com/files/gb.svg?ai=0",
      "custom_title": "gb",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 10,
    "name": "Nemecký jazyk",
    "locale": "de",
    "image": {
      "id": 11,
      "name": "de.svg",
      "url": "https://api.lumibau.com/files/de.svg?ai=0",
      "custom_title": "de",
      "is_ai_generated": false
    },
    "is_default": false
  }
];
